import React from 'react';
import Routes from 'routes/admin/contacts/routes';
import { Redirect } from 'react-router-dom';

const HomeContacts = () => (
  <Redirect to={Routes.listRecipients} />
);

export default HomeContacts;
